<div class="flex items-center justify-center px-4 py-8 lg:py-12">
  <div class="w-full max-w-md p-8 rounded-lg shadow-xl border border-gray-50 text-center space-y-6">

    <div class="space-y-2">
      <h1 class="text-3xl font-semibold text-[#0D3543]">{{ 'auth.forgotPassword.title' | translate }}</h1>
      <p class="text-[#6C7688] text-sm font-normal">
        {{ 'auth.forgotPassword.description' | translate }}
      </p>
    </div>

    <form (ngSubmit)="onSubmit()" class="space-y-6 text-left">

      @if (errorMessage) {
      <div class="p-3 bg-red-50 text-red-600 text-sm rounded-lg border border-red-200">
        {{ errorMessage }}
      </div>
      }

      <div>
        <label class="block text-[#0D3543] mb-2 text-sm">{{ 'auth.common.email' | translate }}</label>
        <div class="relative flex items-center">
          <sham-i-mail-01-Bulk class="absolute start-3 text-[#6C737F] *:size-5" />
          <input type="email" name="email" [(ngModel)]="email" [placeholder]="'auth.common.email' | translate"
            class="w-full ps-10 pe-4 py-3 border border-[#BBDEEB] rounded-lg focus:ring-2 focus:ring-secondary/20 outline-none text-[#0D3543] placeholder:text-gray-300"
            required>
        </div>
      </div>

      <button type="submit" [disabled]="isLoading"
        class="w-full bg-[#2596BE] hover:bg-[#1a7a9c] text-[#FFFFFF] font-medium py-3 rounded-lg transition-all flex justify-center items-center">
        @if (isLoading) {
        <span class="loading loading-spinner loading-sm"></span>
        } @else {
        {{ 'auth.common.submit' | translate }}
        }
      </button>
    </form>

    <p class="text-xs text-gray-500">
      {{ 'auth.common.returnTo' | translate }} <a routerLink="/auth/login"
        class="text-[#2187AB] font-medium hover:underline">{{ 'auth.common.login' | translate }}</a>
    </p>

  </div>
</div>
